import { Injectable } from '@angular/core';

import type { LanguageItem } from '../i18n.service';
import { TranslationsProvider } from '../i18n.service';
import type { Translations } from '../i18n.tokens';
import type { SupportedTranslations } from '../phrase-app/phrase-app-translation.service';

@Injectable()
export class MultilangTranslationService extends TranslationsProvider {
  public hasEditor: boolean = false;
  public defaultLocale: SupportedTranslations;
  public locale: string;
  public availableLocales: string[] = [];

  private availableLanguagesList: LanguageItem[];
  private translations: Translations;

  constructor() {
    super();
    this.hasEditor = false;
  }

  public lookup(key: string): string | null {
    return this.translations[key];
  }

  public setTranslations(translations: Translations): void {
    this.translations = translations;
  }

  public setAvailableLanguagesList(languagesList: LanguageItem[]): void {
    this.availableLanguagesList = languagesList;
    this.availableLocales = this.availableLanguagesList.map(language => language.code);
  }

  public getAvailableLanguagesList(): LanguageItem[] {
    return this.availableLanguagesList;
  }

  public setLocale(locale: SupportedTranslations): boolean {
    const canSet = !!this.availableLanguagesList.find(language => language.code === locale);
    if (canSet) {
      this.locale = locale;
      this.defaultLocale = locale;
      this.localeChanged.next(locale);
    }

    return canSet;
  }
}
